import React, { useState, useEffect } from 'react';

const Input = props => {
  const {
    type, value, placeholder, confirmValue, onChange, onError, validate, className,
  } = props;
  const [prevValue, setPrevValue] = useState(value);
  const [ran, setRan] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (value !== prevValue || (ran === false && value)) {
      setPrevValue(value);
      setRan(true);

      let regex;
      let valid = true;
      let err = '';
      if (validate !== false) {
        if (type === 'email') {
          regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          valid = regex.test(value);
          err = 'Please enter a valid email.';
        } else if (type === 'text') {
          valid = value.length > 0;
          err = 'Please enter a value.';
        } else if (type === 'number') {
          valid = /^(-)?\d*$/.test(value);
          err = 'Please enter a number.';
        } else if (type === 'password') {
          regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
          valid = regex.test(value);
          err = 'Please enter: \nat least a number, \na capital letter, \nand a minimum of 8 characters.';
        } else if (type === 'confirm-password') {
          valid = value === confirmValue;
          err = 'Please confirm your password.';
        }

        if (!valid) {
          setError(err);
          onError(err);
        } else {
          setError('');
          onError('');
        }
      }
    }
  }, [value, ran, prevValue, confirmValue, validate, type, onChange, onError]);
  return (
    <>
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type === 'confirm-password' ? 'password' : type}
        className={error ? `${className} error-outline` : className}
      />
      <div className="error">{error}</div>
    </>
  );
};
export default Input;
